import React, { useEffect, useState } from 'react'
import SidebarMenu from '../SideBarMenu/SideBarMenu'
import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { Home, Server, User, Award, Clock } from 'react-feather'
import HelpFaqCard from '../HelpFaqCard/HelpFaqCard'
import { useFeatureFlags } from '../../utils/FeatureFlags/useFeatureFlags'
import CustomDrawer from '../CustomDrawer/CustomDrawer'
import { MenuOption } from '../SideBarMenu/types'
import { AGENT_MANAGER_PATH } from '../../routes/AgentManagerRoutes'
import { CAMPAIGN_MANAGER_PATH } from '../../routes/CampaignManagerRoutes'
import { SCHEDULER_MANAGER_PATH } from '../../routes/SchedulerManagerRoutes'
import { HOME_PATH } from '../../routes/HomeRoutes'
import { DASHBOARD_PATH } from '../../routes/DashboardRoutes'
import { useTranslation } from 'react-i18next'
import { CAMPAIGN_DETAILS_PATH } from '../../routes/CampaignDetailsRoutes'
import useCommonVars from '../../utils/FeatureFlags/useCommonVars'

export default function AppLayout() {
	// State to manage drawer open/close
	const [isDrawerOpen, setIsDrawerOpen] = useState(false)
	const [menuOptions, setMenuOptions] = useState<MenuOption[]>([])
	const { FRONTEND_AGENT_MANAGER_PAGE, FRONTEND_SCHEDULER_MANAGER } = useFeatureFlags()
	const { t } = useTranslation()
	const { PROPAI_FAQ_URL } = useCommonVars()

	// Event handlers for hover
	const handleMouseEnter = () => {
		setIsDrawerOpen(true)
	}

	const handleMouseLeave = () => {
		setIsDrawerOpen(false)
	}

	const maxWidthMainContent = 3000 // 250px accounts for the drawer width + some margin

	useEffect(() => {
		const menuOptions = [
			{
				label: t('sidebar_menu.option.home'),
				path: HOME_PATH,
				MenuIcon: Home,
				location: [HOME_PATH],
			},
			{
				label: t('sidebar_menu.option.campaign_manager'),
				path: CAMPAIGN_MANAGER_PATH,
				MenuIcon: Server,
				location: [CAMPAIGN_MANAGER_PATH, CAMPAIGN_DETAILS_PATH],
			},
		] as unknown as MenuOption[]

		if (FRONTEND_AGENT_MANAGER_PAGE) {
			menuOptions.push({
				label: t('sidebar_menu.option.agent_manager'),
				path: AGENT_MANAGER_PATH,
				MenuIcon: User,
				location: [AGENT_MANAGER_PATH],
			})
		}

		if (FRONTEND_SCHEDULER_MANAGER) {
			menuOptions.push({
				label: t('sidebar_menu.option.scheduler'),
				path: SCHEDULER_MANAGER_PATH,
				MenuIcon: Clock,
				location: [SCHEDULER_MANAGER_PATH],
			})
		}

		menuOptions.push({
			label: t('sidebar_menu.option.dashboard'),
			path: DASHBOARD_PATH,
			MenuIcon: Award,
			location: [DASHBOARD_PATH],
		})

		setMenuOptions(menuOptions)
	}, [FRONTEND_AGENT_MANAGER_PAGE, FRONTEND_SCHEDULER_MANAGER, t])

	return (
		<Box sx={{ display: 'flex' }}>
			<CustomDrawer
				variant="permanent"
				open={isDrawerOpen}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				anchor="left"
			>
				<SidebarMenu sidebarOpen={isDrawerOpen} menuOptions={menuOptions} />
			</CustomDrawer>
			<Box
				display="flex"
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				sx={{
					flexGrow: 2,
					paddingTop: '30px',
					width: '100%',
					maxWidth: maxWidthMainContent,
				}}
			>
				<Outlet />
			</Box>
			<HelpFaqCard url={PROPAI_FAQ_URL} />
		</Box>
	)
}
